import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SharedNavbar from '@/components/feature/SharedNavbar';
import SharedFooter from '@/components/feature/SharedFooter';
import { ICONS, Icon, usePrefix } from '@/pages/info/v2/InfoShell';
import '../../home/v2/home-v2.css';
import '../../content/v2/content-v2.css';
import '../../info/v2/info-v2.css';
import './partner-v2.css';

// New-design confirmation after a partner application (/partner-apply/success).

export default function PartnerSuccessV2() {
  const { t } = useTranslation();
  const prefix = usePrefix();
  const next = [
    t('infoV2.partner.n1', 'We review your documents'),
    t('infoV2.partner.n2', 'Our partnership team calls you'),
    t('infoV2.partner.n3', 'Your store goes live on Where to Buy'),
  ];
  return (
    <>
      <SharedNavbar />
      <main className="w-full min-h-screen bg-white">
        <div className="v2 cnt inf" style={{ paddingTop: 'var(--v2h-h, 64px)' }}>
          <section className="pdone">
            <div className="wrap">
              <div className="pdc">
                <span className="pok">
                  <Icon d={ICONS.check} />
                </span>
                <h1>{t('partnerApply.success.title')}</h1>
                <p>{t('partnerApply.success.body')}</p>
                <ol>
                  {next.map((s, i) => (
                    <li key={i}>
                      <em>{String(i + 1).padStart(2, '0')}</em>
                      {s}
                    </li>
                  ))}
                </ol>
                <div className="pbt">
                  <Link to={prefix + '/stores'} className="btn dark">
                    {t('partnerApply.success.back')}
                    <Icon d={ICONS.arrow} />
                  </Link>
                  <Link to={prefix + '/'} className="btn ghost">
                    {t('infoV2.partner.home', 'Back to home')}
                  </Link>
                </div>
              </div>
            </div>
          </section>
        </div>
        <SharedFooter />
      </main>
    </>
  );
}
